import { render, staticRenderFns } from "./FormulateTriCheckbox.vue?vue&type=template&id=5e52d3bb&"
import script from "./FormulateTriCheckbox.js?vue&type=script&lang=js&"
export * from "./FormulateTriCheckbox.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/mijnmooiestraat.vlaanderen/staging.mijnmooiestraat.vlaanderen/pro-staging.mijnmooiestraat.vlaanderen/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e52d3bb')) {
      api.createRecord('5e52d3bb', component.options)
    } else {
      api.reload('5e52d3bb', component.options)
    }
    module.hot.accept("./FormulateTriCheckbox.vue?vue&type=template&id=5e52d3bb&", function () {
      api.rerender('5e52d3bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/Formulate/FormulateTriCheckbox/FormulateTriCheckbox.vue"
export default component.exports